import { initMain } from "./vue/controllers/main";
import { header } from "./vue/controllers/header";
import VueTinySlider from "vue-tiny-slider";
import stickyScroll from "./features/sticky-scroll";
import { initIntersections } from "./features/new-lazy-load";

initIntersections();
stickyScroll();
initMain([], {
  VueTinySlider,
});
header();
